import * as THREE from 'three';
import { FikoGrup } from './FikoGrup';
import { FikoSahne } from './FikoSahne';

/**
 * Ölçüm gösterimlerini içeren grup sınıfı
 * Ürün ağacında "Ölçümler" grubu olarak görünür
 */
export class FikoOlcumler extends FikoGrup {
  override type = 'FikoOlcumler';

  private olcumSayisi: number = 0;

  constructor(public override sahne?: FikoSahne) {
    super(sahne, 'Ölçümler');

    // UI Ayarları
    this.userData['FikoArayuz'] = {
      agactaGorunur: true,
      simge: '📐',
      baslik: 'Ölçümler',
      renk: '#FFD700' // CATIA tarzı altın sarısı
    };

    // Render order
    this.renderOrder = 999998;
  }

  /**
   * Yeni ölçüm grubu ekle
   */
  olcumEkle(grup: THREE.Group, baslik: string): void {
    // Ölçüm grubunu adlandır
    const olcumNo = ++this.olcumSayisi;
    grup.name = `Ölçüm_${olcumNo}_${baslik}`;

    // Ölçüm verilerini userData'da tut
    grup.userData = {
      ...grup.userData,
      FikoArayuz: {
        agactaGorunur: true,
        simge: '📏',
        baslik: baslik,
        renk: '#22c55e'
      },
      olcumNo: olcumNo,
      olcumBaslik: baslik,
      olusturmaTarihi: new Date()
    };

    // Sahneye ekle
    this.add(grup);
  }

  /**
   * Son ölçümü sil
   */
  sonOlcumuSil(): void {
    if (this.children.length > 0) {
      const sonOlcum = this.children[this.children.length - 1];
      this.remove(sonOlcum);

      // Geometri ve materyal temizle
      if (sonOlcum instanceof THREE.Group) {
        sonOlcum.traverse((child) => {
          if (child instanceof THREE.Mesh || child instanceof THREE.Line) {
            if (child.geometry) child.geometry.dispose();
            if (child.material) {
              if (Array.isArray(child.material)) {
                child.material.forEach(m => m.dispose());
              } else {
                child.material.dispose();
              }
            }
          }
        });
      }

    }
  }

  /**
   * Tüm ölçümleri temizle
   */
  temizle(): void {
    this.children.forEach((olcum) => {
      if (olcum instanceof THREE.Group) {
        olcum.traverse((child) => {
          if (child instanceof THREE.Mesh || child instanceof THREE.Line) {
            if (child.geometry) child.geometry.dispose();
            if (child.material) {
              if (Array.isArray(child.material)) {
                child.material.forEach(m => m.dispose());
              } else {
                child.material.dispose();
              }
            }
          }
        });
      }
    });

    this.clear();
    this.olcumSayisi = 0;
  }

  /**
   * Ölçüm sayısını al
   */
  olcumSayisinuAl(): number {
    return this.children.length;
  }

  /**
   * ✅ PERFORMANS: Batch disposal - CATIA seviyesi hızlı temizlik
   * Dialog kapatıldığında veya sahne değiştiğinde çağrılmalı
   */
  dispose(): void {
    // Batch disposal - tüm ölçümleri tek seferde temizle (daha hızlı)
    const children = [...this.children]; // Array copy (iterate sırasında değişmeyecek)

    children.forEach((olcum) => {
      // FikoOlcumCizgisi ise dispose çağır
      if ((olcum as any).dispose && typeof (olcum as any).dispose === 'function') {
        (olcum as any).dispose();
      } else if (olcum instanceof THREE.Group) {
        // Standart grup ise manuel temizle
        olcum.traverse((child) => {
          if (child instanceof THREE.Mesh || child instanceof THREE.Line) {
            if (child.geometry) child.geometry.dispose();
            if (child.material) {
              if (Array.isArray(child.material)) {
                child.material.forEach(m => m.dispose());
              } else {
                child.material.dispose();
              }
            }
          }
        });
      }
    });

    // Tüm child'ları temizle
    this.clear();
    this.olcumSayisi = 0;
  }
}
